export function coalescePage(page?: string | null) {
  return Math.max(0, Number.parseInt(page || "1", 10) - 1);
}
